exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1s8Uq,._2Z4rO,.yhGCe{display:-webkit-box;display:-ms-flexbox;display:flex}._1s8Uq{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._1s8Uq .yhGCe,._2Z4rO{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._2Z4rO .yhGCe{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._2RhLz svg{margin:2px 5px 0 0}._2RhLz{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:6px;font-size:12px;line-height:14px;color:gray;margin-right:5px}", ""]);

// exports
exports.locals = {
	"rootRow": "_1s8Uq",
	"rootColumn": "_2Z4rO",
	"chunk": "yhGCe",
	"item": "_2RhLz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/TransportGridDetails/TransportGridDetails.css
// module id = 2433
// module chunks = 15 20